<template>
  <div>
    <div v-if="Object.keys(errors).length > 0" class="alert alert-danger">
      <p v-for="error in errors" class="errors">
        {{ error }}
      </p>
    </div>
    <div>
      Subtract
      <span :class="{'has-error':errors.subtractPointValue}">
        <input :value="subtractPointValue" class="form-control input-numeric" name="subtractPointValue" @input="handleChange">
      </span>
      points from the balance.
    </div>
  </div>
</template>
<script>
  import BaseComponent from '@/EventLogic/components/BaseComponent.vue';

  export default {
    extends: BaseComponent,
    props: {
      id: String,
      // Fundamentally numbers, but often stored as a string
      subtractPointValue: [Number, String],
    },
    methods: {
      validate: function() {
        this.errors = {};

        if (!this.isNumber(this.subtractPointValue) || this.subtractPointValue < 0) {
          this.errors.subtractPointValue = "Please enter a positive amount of points to remove.";
        }
        
        return Object.keys(this.errors).length === 0;
      }
    }
  };
</script>
